import { MappedImage } from "src/utils/fw"

export default ({slots, links, img}) => {
    return <MappedImage links={links.map((it, idx) => {
        return {
            ...it,
            href: slots[idx]?.href || "",
            label: slots[idx]?.label || "",
            external: true,
            target: "_blank"
        }
    })} imageURL={img}/>
}

export const slot = (qtt, props) => {
    const {space, init, height, width, top, left} = {
        space: 7.5, 
        init: 12.5, 
        height: 6.7,
        width: 60.8,
        top: 12.5,
        left: 18.6,
        ...props
    }

    const obj =  {
        width: `${width}%`,
        height: `${height}%`,
        top: `${init}%`,
        left: `${left}%`
    }

    return new Array(qtt).fill(obj).map((it, idx) => {
        return {...it, top: `${(space * idx) + init - 0.1}%`}
    })
}